/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { resourceList } from './api';
const isResourceId = (resource) => {
    return ((resource === null || resource === void 0 ? void 0 : resource.type) && resource.id) && resourceList.includes(resource.type);
};
const isResourceType = (resource) => {
    return resource && (typeof resource.type !== 'undefined') && resource.type && resourceList.includes(resource.type);
};
export { isResourceId, isResourceType };
